import { Alert, Code, Stack } from '@mantine/core';
import { useState } from 'react';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import StyledButton from '@/components/StyledButton/StyledButton.tsx';
import { getHttpErrorMessage } from '@/services/httpRetry.ts';

export default function DiagnosticDefinitionPanel({
  automationId,
  runId,
}: {
  automationId: string;
  runId: string;
}) {
  return (
    <RetainedDefinition
      key={`${automationId}:${runId}`}
      automationId={automationId}
      runId={runId}
    />
  );
}

function RetainedDefinition({ automationId, runId }: { automationId: string; runId: string }) {
  const apiClient = useApiClient();
  const [definition, setDefinition] = useState<unknown>();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();
  const inspect = async () => {
    if (busy) return;
    setBusy(true);
    setError(undefined);
    try {
      const response = await apiClient.get(
        `/automations/${automationId}/runs/${runId}/diagnostic-definition`,
      );
      setDefinition(response.data);
    } catch (cause) {
      setError(getHttpErrorMessage(cause) || 'Could not load the retained definition.');
    } finally {
      setBusy(false);
    }
  };
  return (
    <Stack gap="xs">
      <StyledButton variant="subtle" onClick={() => void inspect()} loading={busy}>
        Inspect retained diagnostic definition
      </StyledButton>
      {error && <Alert color="yellow">{error}</Alert>}
      {definition !== undefined && <Code block>{JSON.stringify(definition, null, 2)}</Code>}
    </Stack>
  );
}
